import React, { useState } from 'react'
import styled from 'styled-components'
import { Flex } from 'ui/acro'
import Text from 'ui/acro/typography/Text'
import AloSignupAndVerifyLinks from './AloSignupAndVerifyLinks'

const Container = styled(Flex)({
  gap: '24px',
  flexDirection: 'column'
})

const Description = styled(Text)({
  color: '#3B3B3B',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const NoSubscriptionNoAloAccessView = () => {
  const [showSignup, setShowSignup] = useState(false)
  return (
    <Container>
      <Description>
        You do not have an active ALO Wellness Club membership. Activate your
        membership and unlock select content at no cost with an ALO account.
      </Description>
      <AloSignupAndVerifyLinks
        showSignup={showSignup}
        setShowSignup={setShowSignup}
        isSettingsPage={true}
        verifyCallbackUrl='/settings/membership'
        signUpCallbackUrl='/settings/membership'
        location='manage_membership'
      />
    </Container>
  )
}

export default NoSubscriptionNoAloAccessView
